import * as React from 'react';
import { IconMinus16, IconPlus16 } from '@cian/ui-kit';

import * as styles from './PlusMinus.css';

const MINUSES = [
  <span key="1">Тратите много времени на поиск объявлений</span>,
  <span key="2">Опасаетесь выбрать неподходящий вариант</span>,
  <span key="3">Задумываетесь, какой дом лучше и&nbsp;комфортнее</span>,
  <span key="4">Сомневаетесь в надёжности застройщика</span>,
  <span key="5">Гадаете, хватит ли денег и&nbsp;одобрят ли&nbsp;ипотеку</span>,
];

const PLUSES = [
  <span key="1">Просто пишете, что нужно, и&nbsp;ждёте звонка</span>,
  <span key="2">Находим варианты, которые вы&nbsp;могли упустить</span>,
  <span key="3">Рассказываем про особенности проекта и&nbsp;ЖК</span>,
  <span key="4">Знаем, надёжный застройщик или не очень</span>,
  <span key="5">Подбираем ЖК, аккредитованные в топ-банках</span>,
];

export const PlusMinus: React.FC = () => {
  return (
    <section className={styles['plus-minus']}>
      <div className={styles['block-minus']}>
        <div className={styles['title']}>Когда ищете сами</div>
        <ul className={styles['list']}>
          {MINUSES.map((minus, index) => (
            <li key={index}>
              <div className={styles['icon-minus']}>
                <IconMinus16 color="superblack_60" />
              </div>
              {minus}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles['block-plus']}>
        <div className={styles['title']}>Когда ищете с Циан</div>
        <ul className={styles['list']}>
          {PLUSES.map((plus, index) => (
            <li key={index}>
              <div className={styles['icon-plus']}>
                <IconPlus16 color="primary_100" />
              </div>
              {plus}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
